import React from 'react'
import {HashRouter} from 'react-router-dom'
import axios from '../../interceptor/http'
import {LayoutOutlined} from '@ant-design/icons';
import './auth.css'

const router = new HashRouter();
export default class Auth extends React.Component{
    constructor(props) {
        super(props);
        this.currentUserInfo = JSON.parse(localStorage.getItem('currentUserAllInfo') || '{}')
        this.state = {
            isFlag:false,
            username: this.currentUserInfo.name || ''
        };
    }
    componentDidMount(){
    }
    login = () => {
        localStorage.removeItem("storeToken");
        localStorage.removeItem("currentUserAllInfo");
        localStorage.removeItem("uuid");
        router.history.push('/Login');
    };
    handleMouseOver = () => {
        this.setState({
            isFlag:true
        })
    };
    handleMouseOut = () => {
        this.setState({
            isFlag:false
        })
    };
    render () {
        let action;
        if(this.state.isFlag){
            action =  <ul className="actionList">
                <li onClick={this.login}><LayoutOutlined />  退出登录</li>
            </ul>
        }else{
            action = ""
        }
        return (
            <div style={{right:'0', position: 'absolute', top: 0, zIndex: 1111}}>
                <label className="actionCls"  onClick={this.handleMouseOver}
                       onMouseLeave={this.handleMouseOut}
                >
                    <img src={require('../../assets/userPic.png')} style={{width:'34px',borderRadius:'50%',marginRight:'5px', verticalAlign:'center'}}/>
                     <span>{this.state.username}</span>
                    {action}
                </label>
            </div>
        )
    }
}
